import ConfirmModal from 'components/ConfirmModal/ConfirmModal';
import { Location } from 'history';
import React, { useEffect, useState } from 'react';
import { Prompt } from 'react-router-dom';

interface Props {
  /**
   * Message of the modal when confirming navigation
   */
  message?: string;

  /**
   * How are we going to change the route eg: path => history.push(path)
   */
  navigate: (location: Location) => void;

  /**
   * Should we block this specific route transition?
   */
  blockLocation: (location: Location) => boolean;

  /**
   * Title of the modal when confirming navigation
   */
  title?: string;

  /**
   * When should we evaluate blocking a route transition
   */
  when?: boolean | undefined;
}

const RouteGuard = ({
  message = 'There are unsaved changes present, if you leave the page those changes will be lost.',
  navigate,
  blockLocation,
  title = 'Unsaved Changes',
  when,
}: Props) => {
  const [showMmodal, setShowModal] = useState(false);
  const [previousLocation, setPreviousLocation] = useState<Location | null>(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  /**
   * Navigation is being guarded, so here we evaluate if we should block our
   * next location
   *
   * @param nextLocation the next location
   */
  const onNavigationChangeRequest = (nextLocation: Location): boolean => {
    if (!confirmedNavigation && blockLocation(nextLocation)) {
      setShowModal(true);
      setPreviousLocation(nextLocation);
      return false;
    }
    return true;
  };

  const handleConfirmNavigationClick = () => {
    setShowModal(false);
    setConfirmedNavigation(true);
  };

  useEffect(() => {
    if (confirmedNavigation && previousLocation) {
      // Navigate to the blocked location
      navigate(previousLocation);
    }
  }, [confirmedNavigation, previousLocation]);

  return (
    <>
      <Prompt when={when} message={onNavigationChangeRequest} />

      <ConfirmModal
        show={showMmodal}
        onClose={() => setShowModal(false)}
        onConfirm={handleConfirmNavigationClick}
        title={title}
        message={message}
      />
    </>
  );
};
export default RouteGuard;
